module.exports = __webpack_public_path__ + "img/home-rbn-7.26568217.png";